import React, { createContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

import CalenderView from "./CalenderView";
import PrimaryButton from "../../utils/buttons/primaryButton";
import TimeView from "./TimeView";
import { setUsedCarSettingInfo } from "../../../redux/usedCarsSlice";
import axiosInstance, {
  notifySuccess,
  notifyWarning,
} from "../../../utility/axiosInstance";
import {
  fetchUsedCars,
  fetchUsedCarsSettingInfo,
} from "../../../redux/usedCarsThunk";
import { getUsedCarData } from "../../../utility/api";
import { AiOutlineLoading } from "react-icons/ai";

export const UsedCarSettingContext = createContext({});

export default function UsedCarSettingIndex({ tab, setTab }) {
  const { t } = useTranslation();

  const weekdays = [
    t("usedCars.settings.weekdays.monday"),
    t("usedCars.settings.weekdays.tuesday"),
    t("usedCars.settings.weekdays.wednesday"),
    t("usedCars.settings.weekdays.thursday"),
    t("usedCars.settings.weekdays.friday"),
    t("usedCars.settings.weekdays.saturday"),
    t("usedCars.settings.weekdays.sunday"),
  ];

  const wkDays = {
    [t("usedCars.settings.weekdays.monday")]: false,
    [t("usedCars.settings.weekdays.tuesday")]: false,
    [t("usedCars.settings.weekdays.wednesday")]: false,
    [t("usedCars.settings.weekdays.thursday")]: false,
    [t("usedCars.settings.weekdays.friday")]: false,
    [t("usedCars.settings.weekdays.saturday")]: false,
    [t("usedCars.settings.weekdays.sunday")]: false,
  };

  const [usedCars, setUsedCars] = useState([]);

  const { usedCarSettingInfo, list } = useSelector((state) => state.usedCars);

  const dispatch = useDispatch();

  const [weeklyCheckbox, setWeeklyCheckbox] = useState(wkDays);
  const [workingTime, setWorkingTime] = useState({
    start: "9:00",
    end: "18:00",
  });
  const [tempTimeSave, setTempTimeSave] = useState([]);

  const [workingDayTime, setWorkingDayTime] = useState([]);
  const [availableWorkingDays, setAvailableWorkingDays] = useState([]);
  const [holidays, setHolidays] = useState([]);
  const [dateValue, onDateChange] = useState(new Date());
  const [currentMonth, onCurrentMonth] = useState(null);
  // const [tab, setTab] = useState(0);

  const [dataLoading, setLoading] = useState(true);

  const [available, setAvailable] = useState([]);
  const [carList, setCarList] = useState([]);
  const [selectedCars, setSelectedCars] = useState([]);
  const [selectedCar, setSelectedCar] = useState(null);

  const [existingCarList, setExistingCarList] = useState([]);

  useEffect(() => {
    if (usedCarSettingInfo?.length < 1) {
      dispatch(fetchUsedCarsSettingInfo({ dispatch }));
      console.log(usedCarSettingInfo, "usedCarSettingInfo");
    }
    if (list?.length < 1) {
      dispatch(fetchUsedCars({ dispatch }));
    } else {
      setUsedCars(list);
    }
  }, [list]);

  const compareTwoDate = (date1, date2) => {
    if (!date1 || !date2) return false;
    const d1 = new Date(date1);
    const d2 = new Date(date2);
    return (
      d1.getUTCFullYear() === d2.getUTCFullYear() &&
      d1.getUTCMonth() === d2.getUTCMonth() &&
      d1.getUTCDate() === d2.getUTCDate()
    );
  };
  const compareMonthAndYear = (date1, date2) => {
    const d1 = new Date(date1);
    const d2 = new Date(date2);

    // Compare month and year
    return (
      d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear()
    );
  };

  const CustomDatePicker = () => {
    const getDate = (date) => {
      return new Date(
        new Date(date).getTime() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .split("T")[0];
    };
    return (
      <span className="text-xl flex items-center gap-5">
        Date:
        {/* <MdOutlineCalendarMonth className="ml-2 mr-1" /> */}
        <span className="text-xl cursor-pointer">
          <input
            type="date"
            // style={{ display: "none" }}
            className="w-64"
            value={dateValue ? getDate(dateValue) : getDate(available[0])}
            onChange={(e) => {
              const newDateValue = e.target.value;
              if (
                !available.find((date) => compareTwoDate(date, newDateValue))
              ) {
                toast.warn(t("serviceSettings.dateNotAvailable"));
                return;
              }
              onDateChange(new Date(newDateValue)); // Trigger date change callback
            }}
          />
        </span>
      </span>
    );
  };
  useEffect(() => {
    if (usedCars?.length > 0) {
      const filtered = usedCars.filter(({ status }) => status == "available");
      setCarList(filtered);
    }
  }, [usedCars]);

  // const onBack = () => {
  //   setTab((count) => (count == 0 ? count : count - 1));
  // };
  const onNext = () => {
    console.log(usedCarSettingInfo, "usedCarSettingInfo");
    if (available.length === 0) {
      toast.warn(t("serviceSettings.dateNotAvailable"));
      return;
    }
    setTab((count) => (count == 1 ? count : count + 1));
  };

  useEffect(() => {
    setLoading(true);
    try {
      if (selectedCars?.length > 0 && usedCarSettingInfo?.length > 0) {
        // const exist = usedCarSettingInfo[0];

        const exist = usedCarSettingInfo?.filter((settings) => {
          if (selectedCars.includes(settings?.car)) {
            return settings;
          }
        });

        if (exist?.length > 0) {
          const {
            workingDetails: { workingTime, weeklySetting },
            holidays,
          } = exist[0];

          if (workingTime && Object.keys(workingTime).length !== 0) {
            setWorkingTime(workingTime);
          }
          if (weeklySetting && Object.keys(weeklySetting).length) {
            setWeeklyCheckbox(weeklySetting);
          }

          if (holidays) {
            setHolidays(holidays);
          }
        }
      } else {
        setHolidays([]);
        setWorkingTime({
          start: "9:00",
          end: "18:00",
        });

        setWeeklyCheckbox(wkDays);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [selectedCar, selectedCars, usedCarSettingInfo]);

  const handleMonthDateUpdate = async (body) => {
    try {
      const { usedCarMonthSetting } = body;

      const modified = usedCarMonthSetting
        ? usedCarMonthSetting?.usedCarDateSettings?.map((ele) => {
            const date = ele.date;
            const modifiedTimeSlots = ele.timeSlots
              ?.map((t) => {
                return {
                  time: t.time,
                  status: t.status.status,
                };
              })
              .filter(({ status }) => status);

            return {
              date: date, // Include the date
              timeSlots: modifiedTimeSlots, // Include the modified time slots
            };
          })
        : body?.workingDayTime?.map((ele) => {
            return {
              time: ele.time,
              status: ele.status.status /*  */,
            };
          });

      const payload = usedCarMonthSetting
        ? {
            ...body,
            usedCarMonthSetting: {
              ...usedCarMonthSetting,
              usedCarDateSettings: modified,
            },
          }
        : { ...body, workingDayTime: modified };

      if (body.usedCars.length < 1) {
        toast.warn(t("usedCars.settings.warnings.noVehiclesSelected"));
        return;
      }
      const response = await axiosInstance.put(
        "usedCarSetting/updateUsedCarSettingInfo",
        {
          ...payload,
        }
      );
      // console.log(response);
      if (response?.status === 200) {
        console.log(response?.data.usedCarSettings);
        dispatch(setUsedCarSettingInfo(response?.data.usedCarSettings));
        notifySuccess("Updated suceccesfully");

        // toast.success("Changed the update");
      }
    } catch (err) {
      console.log(err);
    } finally {
    }
  };
  const handleSingleUpdate = async (body) => {
    try {
      if (body.usedCars.length < 1) {
        toast.warn("No Vehicles is Selected");
        return;
      }
      console.log(body);
      // return
      const response = await axiosInstance.put(
        "usedCarSetting/updateUsedCarSettingInfoWithDate",
        {
          ...body,
        }
      );

      if (response?.status === 200) {
        dispatch(setUsedCarSettingInfo(response?.data.usedCarSettings));
        notifySuccess("Updated sucessfully");
        // toast.success("Changed the update");
      }
    } catch (err) {
      console.log(err);
    } finally {
    }
  };
  const onHandleWOS = async (body) => {
    try {
      const response = await handleMonthDateUpdate({
        weeklySetting: weeklyCheckbox,
        usedCars: selectedCar ? [selectedCar] : selectedCars,
      });
    } catch (err) {
      console.log(err);
    } finally {
    }
  };
  useEffect(() => {
    const tempAllDate = [];

    if (available.length > 0) {
      available.forEach((element) => {
        tempAllDate.push({
          date: element,
          timeSlots: workingDayTime,
        });
      });

      setAvailableWorkingDays(tempAllDate);
    }
  }, [available, workingDayTime]);

  if (dataLoading) {
    <div>
      <AiOutlineLoading className="h-6 w-6 animate-spin m-auto" />
    </div>;
  }
  return (
    <UsedCarSettingContext.Provider
      value={{
        dataLoading,
        handleSingleUpdate,
        handleMonthDateUpdate,
        CustomDatePicker,
        weeklyCheckbox,
        weekdays,
        setWeeklyCheckbox,
        dateValue,
        onDateChange,
        workingTime,
        setWorkingTime,
        workingDayTime,
        setWorkingDayTime,
        availableWorkingDays,
        setAvailableWorkingDays,
        selectedCars,
        setSelectedCars,
        selectedCar,
        setSelectedCar,
        carList,
        setCarList,
        compareTwoDate,
        holidays,
        setHolidays,
        onHandleWOS,
        currentMonth,
        onCurrentMonth,
        available,
        setAvailable,
        compareMonthAndYear,
        tempTimeSave,
        setTempTimeSave,
        usedCars,
      }}
    >
      <div className="py-8 flex flex-col w-[100%] gap-10">
        {tab === 0 ? (
          <CalenderView />
        ) : (
          <div className="flex flex-col gap-5">
            <TimeView />
            {/* <WeekSettingComponent />
            <ServiceListComponent /> */}
          </div>
        )}

        <div className="flex gap-1 justify-end px-10 mb-10 lg:mb-0">
          {/* <PrimaryButton
            width="120px"
            className={`bg-white border border-redBackground `}
            title={"Back"}
            textClass={"text-redBackground "}
            onClick={onBack}
            // loading={isMLoading}
          /> */}
          {tab < 1 && (
            <PrimaryButton
              width="140px"
              title={t("next")}
              onClick={onNext}
              // onClick={() => updateHoliday(dateValue)}
              // loading={isLoading}
            />
          )}
        </div>
      </div>
    </UsedCarSettingContext.Provider>
  );
}
